import React from 'react'
// import BreadCrumb from '../../components/Global/Breadcrumb/BreadCrumb'
import AllBlogCategory from './AllBlogCategory'

function MarketingCategory() {
  return (
    <>
      <AllBlogCategory />
    </>
  )
}

export default MarketingCategory
